import { useSelector } from 'react-redux';
import { RootState, useAppDispatch } from 'store';
import { submitWizardData } from '../store/wizardApi';
import { useWizardContext } from './useWizardContext';

export function useWizardSubmit() {
    const dispatch = useAppDispatch();
    const { config } = useWizardContext();
    const { formData, metadata } = useSelector((state: RootState) => state.wizard);

    const handleSubmit = async (): Promise<{ success: boolean; data?: any; error?: string }> => {
        try {
            const payload = config.createPayload(formData, metadata);

            const result = await dispatch(
                submitWizardData({
                    payload,
                    submitFunction: config.submitWizard,
                })
            ).unwrap();

            return { success: true, data: result };
        } catch (error: any) {
            let errorMessage = 'Submission failed. Please try again.';

            if (error?.message) {
                errorMessage = error.message;
            } else if (error?.error) {
                errorMessage = error.error;
            } else if (typeof error === 'string') {
                errorMessage = error;
            }

            return { success: false, error: errorMessage };
        } finally {
        }
    };
    return { handleSubmit };
}
